var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "is-size-6", class: _vm.determineClasses() },
    [
      _c(
        "div",
        { staticClass: "cart-item-options", class: _vm.highlightSibling("0") },
        [
          _vm.isDivisible()
            ? _c("BaseIcon", {
                staticClass: "divisible-icon",
                class: _vm.styleClassWholeOption(),
                attrs: {
                  fill: false,
                  isCustom: true,
                  icon: _vm.$appConstants.items.choices.icons.divisionWhole,
                  size: "2x"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "listed-choices",
            domProps: { innerHTML: _vm._s(_vm.listChoices("0", this.options)) },
            on: { click: _vm.listChoiceClickHandler }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cart-item-options", class: _vm.highlightSibling("1") },
        [
          !_vm.isMinified
            ? _c("BaseIcon", {
                staticClass: "divisible-icon",
                attrs: {
                  fill: false,
                  isCustom: true,
                  icon: _vm.$appConstants.items.choices.icons.divisionLeft,
                  size: "2x"
                }
              })
            : _c("p", { staticClass: "item-side" }, [_vm._v("Left: ")]),
          _vm._v(" "),
          _c("div", {
            staticClass: "listed-choices",
            domProps: { innerHTML: _vm._s(_vm.listChoices("1", this.options)) },
            on: { click: _vm.listChoiceClickHandler }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cart-item-options", class: _vm.highlightSibling("2") },
        [
          !_vm.isMinified
            ? _c("BaseIcon", {
                staticClass: "divisible-icon",
                attrs: {
                  fill: false,
                  isCustom: true,
                  icon: _vm.$appConstants.items.choices.icons.divisionRight,
                  size: "2x"
                }
              })
            : _c("p", { staticClass: "item-side" }, [_vm._v("Right: ")]),
          _vm._v(" "),
          _c("div", {
            staticClass: "listed-choices",
            domProps: { innerHTML: _vm._s(_vm.listChoices("2", this.options)) },
            on: { click: _vm.listChoiceClickHandler }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8521ebc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8521ebc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/CartItemInfoSiblings.vue
// module id = null
// module chunks = 